<template>
  <el-container style="height: 100vh;">
    <!-- 侧边栏 -->
  <el-aside :width="isCollapse ? '64px' : '200px'" class="sidebar-container">
      <sidebar :is-collapse="isCollapse"></sidebar>
    </el-aside>
    
    <el-container>
      <!-- 顶部导航 -->
      <el-header class="header-container">
        <header-nav @toggle-collapse="toggleCollapse"></header-nav>
      </el-header>
      
      <!-- 主内容区 -->
      <el-main class="main-container">
        <breadcrumb></breadcrumb>
        <transition name="fade-transform" mode="out-in">
          <router-view />
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Sidebar from './Sidebar';
import HeaderNav from './Header';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'AppLayout',
  components: {
    Sidebar,
    HeaderNav,
    Breadcrumb
  },
  data() {
    return {
      isCollapse: false
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    }
  }
};
</script>

<style scoped>
.sidebar-container {
  background-color: var(--color-sidebar-bg);
  color: #fff;
  height: 100%;
}

.header-container {
  text-align: right;
  font-size: 12px;
  line-height: 60px;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px;
}

.main-container {
  padding: 20px;
  background-color: var(--color-bg);
  height: calc(100vh - 60px);
  overflow-y: auto;
}
</style>
